import validate from 'validate.js';

const constraints = {
    title: {
	presence: { 
	    message: 'napiši naslov'
	}
    },
    subtitle: {
	presence: { 
	    message: 'napiši podnaslov'
	}
    },
    title_font: {
	presence: function(value, attributes) {
	    if(attributes.category){
		return {message:'zberi font'}	
	    }
	}
    },
    title_position: {
	presence: function(value, attributes) {
	    if(attributes.category){
		return {message:'zberi pozicijo'}	
	    }
	}
    },
    location: {
	presence: function(value, attributes) {
	    if(attributes.category){
		return {message:'napiši lokacijo'}	
	    }
	}
    },
    description: {
	presence: { 
	    message: 'napiši opis'
	}
    },

    event_on: {
	presence: function(value, attributes) {
	    if(attributes.category){
		return {message:'izberi datum'}	
	    }
	}
    }
}

const EventValidator = ( fields ) => {
    var validations= validate(fields, constraints, {fullMessages: false}) || {};
 
    return validations
}

export default EventValidator ;



// WEBPACK FOOTER //
// ./src/validators/EventValidator.js